export const getDowngradeLimitAlertMessageOptions = ({
  numContentObjectsOverLimit,
  numContentGroupObjectsOverLimit,
  contentGroupLimit,
  contentObjectLimit,
  hasExceededContentObjectLimit,
  hasExceededContentGroupLimit
}) => {
  if (hasExceededContentObjectLimit && hasExceededContentGroupLimit) {
    return {
      langKey: numContentGroupObjectsOverLimit === 1 ? 'content-management-restrictions-lib.downgradeLimitAlerts.exceededContentObjectAndContentGroupLimit.oneContentGroupOverLimit' : 'content-management-restrictions-lib.downgradeLimitAlerts.exceededContentObjectAndContentGroupLimit.manyContentGroupsOverLimit',
      titleOptions: {
        count: numContentObjectsOverLimit,
        numContentGroupObjectsOverLimit
      },
      messageOptions: {
        count: contentGroupLimit,
        contentObjectLimit
      },
      dataTestId: 'downgrade-alert-content-group-and-content-object-limit'
    };
  } else if (hasExceededContentGroupLimit) {
    return {
      langKey: 'content-management-restrictions-lib.downgradeLimitAlerts.exceededContentGroupLimit',
      titleOptions: {
        count: numContentGroupObjectsOverLimit
      },
      dataTestId: 'downgrade-alert-content-object-limit',
      messageOptions: {
        count: contentGroupLimit
      }
    };
  }
  return {
    langKey: 'content-management-restrictions-lib.downgradeLimitAlerts.exceededContentObjectLimit',
    titleOptions: {
      count: numContentObjectsOverLimit
    },
    messageOptions: {
      count: contentObjectLimit
    },
    dataTestId: 'downgrade-alert-content-object-limit'
  };
};